import * as Yup from 'yup'
import {LoginSchema} from 'definitions/Yup'
import {FC} from 'react'

export interface OnboardingQueryParams {
  domainAdminExist?: string
  token?: string
  domainEmail?: string
  loggedInUser?: string
  loginStatus?: boolean
  invalid_email?: boolean
  onboardingStatus?: string
  unverified_email?: boolean
  tenants?: string
  need_help?: boolean
}

export interface GetTokenReqType {
  token: string
  tenants?: string
  pageRefresh?: boolean
}

export interface UserInfo {
  accessToken: string
  refreshToken: string
  name: string
  emailId: string
  authProvider: string
  primaryDomain: string
  usersImported: boolean
  role: string
}
export interface AccountList {
  listOfDomains: string[]
  token: string
}

export interface StorageLocationPayload {
  country: string
}

export type LoginFormData = Yup.InferType<typeof LoginSchema>

export enum AUTH_PROVIDER {
  google = 'google',
  microsoft = 'microsoft',
}

export enum AUTH_PROVIDER_DISPLAY_VALUE {
  google = 'Google',
  microsoft = 'O365',
}

export interface SetSyncErrorType {
  filter: string
  message: string
}

export interface SetTokenResponse {
  respData: UserInfo
  reqPayload: GetTokenReqType
}

// Define the common props interface that all step components share
export interface OnboardingStepProps {
  onSubmit: () => void
  onPrev: () => void
}

// Define the type for the Onboarding Steps
export type OnboardingSteps = Record<number, FC<OnboardingStepProps>>
